// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import Notifications from 'vue-notification'
import store from './store'
import language from './language'
import VueCountryCode from 'vue-country-code-select'
Vue.config.productionTip = false
Vue.use(Notifications)
Vue.config.app = process.env
Vue.use(require('vue-moment'))

Vue.config.errorHandler = function (error, vm, info) {
  console.log(error, vm, info)
}
Vue.config.app = process.env
Vue.prototype._i18n = language

Vue.use(VueCountryCode)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js